<template>
    <div>
        <page-title-bar></page-title-bar>
        <v-container grid-list-xl pt-0>
            <page-tool-bar show_search :loading="loader" :search.sync="search">
                <v-flex xs12 md2>
                    <div style="max-width: 290px" class="mr-3">
                        <v-menu :close-on-content-click="false" v-model="menu_month_picker" :nudge-right="40" lazy
                            transition="scale-transition" offset-y full-width min-width="290px" max-width="290px"
                            :disabled="loader">
                            <v-text-field slot="activator" v-model="chosen_month" label="Chọn tháng" :disabled="loader"
                                prepend-icon="event" readonly hide-details></v-text-field>
                            <v-date-picker locale="vi-VI" type="month" v-model="chosen_month"
                                @input="menu_month_picker = false"></v-date-picker>
                        </v-menu>
                    </div>
                </v-flex>
                <v-flex xs12 md2>
                    <div class="text-right d-flex align-center">
                        <v-select v-model="billType" :items="['Điện', 'Nước']" label="Chọn loại hóa đơn" outlined dense
                            hide-details class="mr-3"></v-select>
                    </div>
                </v-flex>

                <v-flex shrink>
                    <div class="text-right">
                        <v-btn @click="export_csv++" color="primary" dark>XUẤT EXCEL</v-btn>
                        <dialog-upload-pdf-dien-nuoc @reloadTable="reload_table++">
                        </dialog-upload-pdf-dien-nuoc>
                    </div>
                </v-flex>
            </page-tool-bar>
            <table-dien-nuoc-nha-nuoc :dateStart="date_start_computed" :dateEnd="date_end_computed"
                :billType="billType" :reloadTrigger="reload_table" :export_csv="export_csv"></table-dien-nuoc-nha-nuoc>
        </v-container>
    </div>
</template>

<script>

import moment from 'moment'
import DialogUploadPdfDienNuoc from "./DialogUploadPdfDienNuoc"
import TableDienNuocNhaNuoc from './TableDienNuocNhaNuoc.vue';

export default {
    name: "dien-nuoc-nha-nuoc-layout",
    components: {
        DialogUploadPdfDienNuoc,
        TableDienNuocNhaNuoc
    },
    data() {
        return {
            reload_table: 0,
            download_csv_count: 0,
            loader: false,
            search: "",
            billType: 'Nước',
            chosen_month: moment().format('YYYY-MM'),
            menu_month_picker: false,
            export_csv: 0
        }
    },
    computed: {
        date_start_computed() {
            if (!this.chosen_month) return '';
            return `${this.chosen_month}-01`;
        },
        date_end_computed() {
            if (!this.chosen_month) return '';
            const [year, month] = this.chosen_month.split('-').map(Number);
            const lastDay = new Date(year, month, 0).getDate();
            return `${this.chosen_month}-${String(lastDay).padStart(2, '0')}`;
        }
    },
    mounted() {
        this.reload_table++
    },
    watch: {
        chosen_month() {
            this.reload_table++
        },
        billType() {
            this.reload_table++
        },
        search() {
            this.reload_table++
        },
    },
}
</script>

<style scoped>
.v-select {
    max-width: 200px;
}
</style>
